<template>
  <modal 
    name="order-details-modal"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Պատվերի մանրամասներ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('order-details-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <label for="name">Մատակարարման վերջնաժամկետ</label>
              <input
                v-model="$v.order.dispatch_date.$model"
                name="dispatch_date"
                type="date"
                class="form-control"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="save" class="btn btn-sm btn-light mr-3">
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import 'vue-date-pick/dist/vueDatePick.css';

  export default {
    name: 'order-details-modal',
    components: {  },
    data() {
      return {
        handleOrder: '',
        order: {
          dispatch_date: '',
        },
      }
    },
    validations() {
      const rules = {
        order: {
          dispatch_date: {required},
        },
      }
      return rules
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
    },
    methods: {
      handleBeforeOpen({params}) {
        this.handleOrder = params.handleOrder;
      },
      save() {
        if(!this.$v.order.$invalid) {
          this.handleOrder(this.order.dispatch_date)
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը պահպանելու համար!'
          })
        }
        
      },
      getContractPrice(participantGroup){
          var sumPrice = 0;
          participantGroup.won_lots.forEach((lot) => {
            const offer = participantGroup.lots.find(item => item.organize_row_id === lot.id)
            console.log(offer)
            const newPrice = offer.new_value
            const price = offer.value
            const vat = offer.vat
              if(vat){
                if(newPrice){
                  sumPrice = sumPrice + (newPrice+newPrice*0.2)
                } else {
                  sumPrice = sumPrice + (price+price*0.2)
                }
              } else {
                if(newPrice){
                  sumPrice = sumPrice + (newPrice)
                } else {
                  sumPrice = sumPrice + (price)
                }
              }
          })
          return sumPrice
        }
    },
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    width: 500px !important;
    position: absolute;
    right: 0 !important;
    left: 0 !important;
    margin: auto;
    height: 60% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>